/* Preserve explicit legacy campaign links and gift-only discovery exclusions. */
(() => {
  'use strict';
  const config=JSON.parse(document.querySelector('[data-flying-routing]')?.textContent||'null');
  if(!config||Number(window.Shopify?.theme?.id)!==config.themeId)return;
  const heroes={
    'spider-man-rc-helicopter':'spider-man',
    'marvel-licensed-avengers-iron-man-2ch-ir-rc-helicopter':'iron-man',
    'hulk-rc-helicopter':'hulk',
    'marvel-licensed-avengers-captain-america-2ch-ir-rc-helicopter':'captain-america',
    'marvel-licensed-x-men-wolverine-2ch-ir-rc-helicopter':'wolverine',
    'deadpool-2ch-jetpack-flying-figure-ir-helicopter':'deadpool'
  };
  const hidden=new Set(['ultimate-hero-squad-6-pack','x23-drone']);
  function destination(source,ready=config.masterPublic){
    const url=new URL(source,location.origin),view=url.searchParams.get('view');
    if(url.pathname!=='/collections/flying-figures'||view!=='hobbytron-flying-figures')return null;
    const hero=heroes[url.searchParams.get('product')];
    if(!hero||!ready)return null;
    url.pathname='/products/marvel-remote-control-flying-figures';url.searchParams.set('hero',hero);
    for(const p of ['product','variant','view'])url.searchParams.delete(p);
    const previewTheme=new URL(location.href).searchParams.get('preview_theme_id');if(previewTheme)url.searchParams.set('preview_theme_id',previewTheme);else url.searchParams.delete('preview_theme_id');return url.href;
  }
  window.FlyingMasterRoutes=Object.freeze({destination,hiddenHandles:[...hidden]});
  const redirect=destination(location.href);if(redirect){location.replace(redirect);return;}
  const handleOf=n=>{if(n.dataset.productHandle)return n.dataset.productHandle;try{const u=new URL(n.href,location.origin);return u.pathname.match(/\/products\/([^/]+)\/?$/)?.[1]||u.searchParams.get('product');}catch(_){return null;}};
  function filter(scope){
    let removed=0;
    for(const link of scope.querySelectorAll('a[href],button[data-product-handle]')){
      if(!hidden.has(handleOf(link)))continue;
      // Never operate on cart lines or purchase forms.
      if(link.closest('cart-items,cart-drawer,form[action*="/cart"],[data-flying-master]'))continue;
      const card=link.closest('.grid__item,.predictive-search__list-item,.arcade-card,.ht-arcade__game,.arcade-categories li');
      if(card){card.remove();removed++;}
      else if(link.closest('nav,.menu-drawer,.header__inline-menu')){link.hidden=true;const li=link.closest('li');if(li&&li.querySelectorAll('a').length===1)li.hidden=true;}
    }
    return removed;
  }
  let pending=false,refilling=false;
  async function clean(){
    pending=false;const removed=filter(document);
    if(removed){for(const n of document.querySelectorAll('#ProductCount,#ProductCountDesktop'))n.textContent='Available products';}
    const grid=document.querySelector('#product-grid');
    if(!grid||grid.querySelector('.grid__item')||refilling)return;
    let next=document.querySelector('.pagination__item--prev')?.href;
    // Dawn names the next-page arrow "prev" because its icon is rotated.
    if(!next){if(removed)grid.textContent='No products match these filters.';return;}
    refilling=true;const visited=new Set();
    try{
      while(next&&!visited.has(next)){
        visited.add(next);const url=new URL(next,location.origin);const previewTheme=new URL(location.href).searchParams.get('preview_theme_id');if(previewTheme)url.searchParams.set('preview_theme_id',previewTheme);else url.searchParams.delete('preview_theme_id');
        const response=await fetch(url,{headers:{Accept:'text/html'}});if(!response.ok)break;
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');filter(doc);
        const replacement=doc.querySelector('#product-grid');const href=doc.querySelector('.pagination__item--prev')?.getAttribute('href');next=href?new URL(href,url).href:null;
        if(replacement?.querySelector('.grid__item')){
          grid.replaceChildren(...replacement.children);
          const pager=document.querySelector('.pagination-wrapper'),fresh=doc.querySelector('.pagination-wrapper');if(pager){if(fresh)pager.replaceWith(fresh);else pager.remove();}
          history.replaceState(history.state,'',url);return;
        }
      }
      grid.textContent='No products match these filters.';
      document.querySelector('.pagination-wrapper')?.remove();
    }catch(_){grid.textContent='Please refresh to load available products.';}
    finally{refilling=false;}
  }
  const schedule=()=>{if(!pending){pending=true;queueMicrotask(clean);}};
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});clean();
})();
